import { each, has, keys, orderBy, remove } from 'lodash';
import dayjs from '../lib/dayjs';
import { DiscountTypeEnum, StatusEnum, UseLimitTypeEnum } from '../enum';
import { findActivityProduct, toFixed } from '../lib/utils';
import todayUsedCntMap from '../variable/todayUsedCntMap';
/**
 * 遍历循环算出最优
 * @param couponProductGroup
 * @param selectItemCouponMap
 */
function outputBestOneItemCoupon(opt) {
    const { selectItemCouponMap, notOrderBy = false } = opt;
    let { couponProductGroup } = opt;
    const output = notOrderBy
        ? couponProductGroup[0]
        : orderBy(couponProductGroup, ['discountFee', 'gapFee'], ['desc', 'asc'])[0];
    if (output) {
        couponProductGroup = remove(couponProductGroup, (group) => group.key === output.key || group.memberCouponId === output.memberCouponId);
        if (output.useLimitType === UseLimitTypeEnum.NoLimit || output.useLimitCnt > todayUsedCntMap.get(output.couponId)) {
            selectItemCouponMap[output.memberCouponId] = output.pk;
            todayUsedCntMap.increase(output.couponId);
        }
    }
    return output;
}
export default function calBestItemCoupon(opt) {
    const { coupons, products, selectItemCouponIds, timeZone, notOrderBy, selectItemCouponMap, alearedJoinFullItemPks, couponsConfigMap, } = opt;
    if (timeZone) {
        dayjs.tz.setDefault(timeZone);
    }
    const productMap = {};
    let productCnt = 0;
    each(products, (product) => {
        productCnt += product.cnt || 1;
        const pk = (product === null || product === void 0 ? void 0 : product.pk) || '';
        if (!alearedJoinFullItemPks.includes(pk) && !product.isFullItemNFree) {
            for (let i = 0; i < ((product === null || product === void 0 ? void 0 : product.cnt) || 1); i++) {
                productMap[pk + ':' + i.toString()] = product;
            }
        }
    });
    const couponProductGroup = [];
    if (coupons) {
        each(selectItemCouponIds, (memberCouponId) => {
            const memberCoupon = coupons[memberCouponId];
            if (memberCoupon.canUse &&
                (memberCoupon.status === StatusEnum.Enable || memberCoupon.status === StatusEnum.Mutex)) {
                if (!selectItemCouponMap[memberCoupon.memberCouponId]) {
                    each(productMap, (orderProduct, key) => {
                        var _a, _b;
                        const nowTime = orderProduct.addTime;
                        if (memberCoupon.startTime > nowTime || memberCoupon.endTime < nowTime) {
                            return true;
                        }
                        if (!memberCoupon.isAllTime) {
                            const nowHourTime = dayjs(nowTime).format('HH:mm');
                            const nowDay = dayjs(nowTime).day();
                            const nowDate = dayjs(nowTime).date();
                            let isPushed = false;
                            if (memberCoupon.timeRangeType === 'month') {
                                if ((_a = memberCoupon.days) === null || _a === void 0 ? void 0 : _a.includes(nowDate)) {
                                    isPushed = true;
                                }
                            }
                            else {
                                each(memberCoupon.timeRanges, (timeRange) => {
                                    if (timeRange.isOpen && timeRange.weekDay === nowDay) {
                                        each(timeRange.ranges, (range) => {
                                            if (range.startTime <= nowHourTime && range.endTime >= nowHourTime) {
                                                isPushed = true;
                                            }
                                        });
                                    }
                                });
                            }
                            if (!isPushed) {
                                return true;
                            }
                        }
                        const findProduct = findActivityProduct(((_b = couponsConfigMap[memberCoupon.couponId]) === null || _b === void 0 ? void 0 : _b.productMap) || {}, orderProduct);
                        if (findProduct &&
                            orderProduct.pk &&
                            !alearedJoinFullItemPks.includes(orderProduct.pk) &&
                            !orderProduct.isFullItemNFree &&
                            ((has(orderProduct, 'isOverlySingleItemDiscount') && orderProduct.isOverlySingleItemDiscount) ||
                                !has(orderProduct, 'isOverlySingleItemDiscount'))) {
                            let discountFee = 0; // 优惠金额
                            let gapFee = 0; // 优惠溢出
                            let productPrice = orderProduct.price;
                            if (memberCoupon.discountType === DiscountTypeEnum.SpecialOffer) {
                                memberCoupon.isIncludeModifier = false;
                            }
                            if (memberCoupon.isIncludeModifier) {
                                productPrice = orderProduct.productAndModifierPrice;
                            }
                            if (memberCoupon.discountType === DiscountTypeEnum.DiscountFee) {
                                discountFee = memberCoupon.discountValue;
                            }
                            else if (memberCoupon.discountType === DiscountTypeEnum.DiscountRate) {
                                discountFee = toFixed(productPrice * (1 - memberCoupon.discountValue));
                            }
                            else if (memberCoupon.discountType === DiscountTypeEnum.SpecialOffer) {
                                discountFee = productPrice - memberCoupon.discountValue;
                            }
                            if (discountFee > productPrice) {
                                discountFee = productPrice;
                            }
                            if (memberCoupon.discountType === DiscountTypeEnum.DiscountFee) {
                                gapFee = Math.abs(memberCoupon.discountValue - discountFee);
                            }
                            couponProductGroup.push({
                                memberCouponId,
                                pk: orderProduct.pk,
                                key,
                                discountFee,
                                gapFee,
                                useLimitCnt: memberCoupon.useLimitCnt || 1,
                                useLimitType: memberCoupon.useLimitType || UseLimitTypeEnum.NoLimit,
                                couponId: memberCoupon.couponId,
                            });
                        }
                    });
                }
            }
        });
        while (couponProductGroup.length > 0) {
            // 这里是死循环
            outputBestOneItemCoupon({ couponProductGroup, selectItemCouponMap, notOrderBy });
            if (keys(selectItemCouponMap).length >= productCnt) {
                break;
            }
        }
    }
    return selectItemCouponMap;
}
//# sourceMappingURL=calBestItemCoupon.js.map